import Icon from '../components/Icon.vue'

Icon.register({
  film: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M488 64c13.3 0 24 10.7 24 24v336c0 13.3-10.7 24-24 24h-8v-20c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v20h-320v-20c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v20h-8c-13.3 0-24-10.7-24-24v-336c0-13.3 10.7-24 24-24h8v20c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-20h320v20c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-20h8zM96 372v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zM96 276v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zM96 180v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zM368 388v-96c0-6.6-5.4-12-12-12h-200c-6.6 0-12 5.4-12 12v96c0 6.6 5.4 12 12 12h200c6.6 0 12-5.4 12-12zM368 220v-96c0-6.6-5.4-12-12-12h-200c-6.6 0-12 5.4-12 12v96c0 6.6 5.4 12 12 12h200c6.6 0 12-5.4 12-12zM480 372v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zM480 276v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zM480 180v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/film.js
// module id = 1352
// module chunks = 0